<template>
  <el-dialog
    :visible="dialogVisible"
    width="500px"
    :before-close="close"
    :close-on-click-modal="false"
    :title="title"
  >
    <el-form ref="userform" :rules="rules" :model="data">
      <el-form-item prop="userIDs" label="选择用户" :label-width="formLabelWidth">
        <el-select filterable multiple v-model="data.userIDs" placeholder="选择添加到该角色的用户" style="width:300px">
          <el-option
            v-for="item in users"
            :key="item.userID"
            :label="item.realName || item.username"
            :value="item.userID"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="Loading">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {
  getEnterpriseUsersApi,
  addUserToRoleApi
} from '@/api/enterpriseManage';
import { errorHandle } from '@/utils/error';
export default {
  name: 'AddUserToRole',
  props: {
    eid: String,
    roleID: String,
    dialogVisible: Boolean,
    onClose: Function,
    onSuccess: Function
  },
  data() {
    return {
      data: {
        userIDs: []
      },
      rules: {
        userIDs: [{ required: true, message: '用户必选', trigger: 'blur' }]
      },
      app: {},
      users: [],
      title: '添加用户到角色',
      formLabelWidth: '80px',
      Loading: false
    };
  },
  created() {
    this.getUsers();
  },
  methods: {
    getUsers() {
      getEnterpriseUsersApi({
        eid: this.eid
      })
        .then(res => {
          this.users = res.users;
        })
        .catch(err => {
          errorHandle(err);
        });
    },
    submit() {
      this.Loading = true;
      this.$refs.userform.validate(valid => {
        if (valid) {
          addUserToRoleApi({
            eid: this.eid,
            userIDs: this.data.userIDs,
            roleID: this.roleID
          })
            .then(res => {
              this.Loading = false;
              this.onSuccess && this.onSuccess();
            })
            .catch(err => {
              this.Loading = false;
              errorHandle(err);
            });
        } else {
          this.Loading = false;
        }
      });
    },
    close() {
      this.$refs.userform.resetFields();
      this.onClose && this.onClose();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/information/roleManage/components/addUserToRole.vue